import { Divider } from '@wix/design-system';
import classnames from 'clsx';
import React from 'react';
import { ClearFilters } from '../../layouts/ClearFilters';
import KeywordSelector from '../../layouts/KeywordSelector';
import StyleSelector from '../../layouts/StyleSelector';
import TLDSelector from '../../layouts/TLDSelector';
import { CoreDomainSearchModule } from '../../module/module';
import s from '../DomainSearchBar/DomainSearchBar.scss';
export const InlineToolbar = _ref => {
  let compact = _ref.compact,
    isFocused = _ref.isFocused,
    availableTlds = _ref.availableTlds,
    concatenatedKeywords = _ref.concatenatedKeywords,
    onFiltersChange = _ref.onFiltersChange;
  const _CoreDomainSearchModu = CoreDomainSearchModule.SDK.Layouts,
    ToolBarContainer = _CoreDomainSearchModu.ToolBarContainer,
    AdditionalToolsContainer = _CoreDomainSearchModu.AdditionalToolsContainer;
  const selectedTlds = CoreDomainSearchModule.SDK.domainInputStore.useTlds();
  const selectedKeywords = CoreDomainSearchModule.SDK.domainInputStore.useKeywords();
  const selectedStyle = CoreDomainSearchModule.SDK.domainInputStore.useStyle();
  const inputRef = CoreDomainSearchModule.SDK.domainInputStore.useInputRef();
  const _CoreDomainSearchModu2 = CoreDomainSearchModule.SDK.domainInputStore,
    setTlds = _CoreDomainSearchModu2.setTlds,
    setKeywords = _CoreDomainSearchModu2.setKeywords,
    setStyle = _CoreDomainSearchModu2.setStyle,
    clearFilters = _CoreDomainSearchModu2.clearFilters;
  const shouldShowClearFilters = selectedTlds.length > 0 || selectedKeywords.length > 0 || !!selectedStyle;
  return /*#__PURE__*/React.createElement(ToolBarContainer, {
    className: classnames(s.toolBar, {
      [s.compact]: compact,
      [s.hasFocus]: isFocused
    })
  }, /*#__PURE__*/React.createElement(TLDSelector, {
    selectedTlds: selectedTlds,
    onChange: tlds => {
      setTlds(tlds);
      inputRef == null || inputRef.focus();
      onFiltersChange == null || onFiltersChange('tlds', tlds);
    },
    availableTlds: availableTlds
  }), /*#__PURE__*/React.createElement("span", {
    className: s.toolsDivider
  }, /*#__PURE__*/React.createElement(Divider, {
    direction: "vertical"
  })), /*#__PURE__*/React.createElement(AdditionalToolsContainer, null, /*#__PURE__*/React.createElement(KeywordSelector, {
    selectedKeywords: selectedKeywords,
    availableKeywords: concatenatedKeywords,
    onChange: keywords => {
      setKeywords(keywords);
      inputRef == null || inputRef.focus();
      onFiltersChange == null || onFiltersChange('keywords', keywords);
    }
  }), /*#__PURE__*/React.createElement(StyleSelector, {
    selectedStyle: selectedStyle,
    onChange: style => {
      setStyle(style);
      inputRef == null || inputRef.focus();
      onFiltersChange == null || onFiltersChange('style', style);
    }
  })), shouldShowClearFilters && /*#__PURE__*/React.createElement(ClearFilters, {
    onClear: clearFilters
  }));
};
export default InlineToolbar;
//# sourceMappingURL=InlineToolbar.js.map